import React from 'react';
import { Outlet } from 'react-router-dom';
import BottomNav from '../../components/BottomNav';

/**
 * Wraps the authenticated customer "hub" pages (Home, Bookings, Booking
 * Details, Profile) so the bottom tab bar is always mounted alongside the
 * page content — no per-page duplication, no missed pages. Checkout-style
 * flows (booking creation, payment, confirmation) intentionally render
 * outside this layout so they stay full-screen and distraction-free.
 */
export default function CustomerNavLayout() {
  return (
    <>
      <Outlet />
      <BottomNav />
    </>
  );
}
